import React from 'react'
import css from '../styles/Projects.module.scss';
import AllProyects from './AllProyects';
import { proyectos } from '../data';

function Proyects() {
    return (
        <div className={css.container}>
            <div className={css.texts}>
                <h1>Proyectos</h1>
                <h4>Estos son algunos de mis proyectos</h4>
                <div className={css.list}>
                    {proyectos.map(e => (
                        <AllProyects key={e.id} img={e.src} link={e.link} name={e.name} tecnologies={e.tecnologies} repo={e.repo} figma={e.figma} behance={e.behance} descripcion={e.descripcion} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Proyects
